module.exports = __webpack_public_path__ + "static/media/Pie chart.0d55b6de.svg";